import React from 'react'
import './Playlist.css'
import TrackList from '../TrackList/TrackList'

const Playlist = (props) => {

  const handleNameChange = (e) => {
    const updatedName = e.target.value
    props.onNameChange(updatedName)
  }

  return (
    <div className="Playlist">
        <input 
          defaultValue={'New Playlist'}
          onChange={handleNameChange}  
        />
        <TrackList 
          tracks={props.playlistTracks}
          onRemove={props.onRemove}
          isRemoval={true}
        />
        <button className="Playlist-save" onClick={props.onSave}>SAVE TO SPOTIFY</button>
    </div>
  )
}

export default Playlist